module.exports = __webpack_public_path__ + "static/media/export.4604e6df.svg";